import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import {Typeahead} from 'react-bootstrap-typeahead';
import moment from 'moment';
import {Table, Button} from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import $ from 'jquery';

var Config = require('../../../config');

class DiscardProductForm extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.addProduct = this.addProduct.bind(this);
		this.onSave = this.onSave.bind(this);
		this.removeUnitFromList = this.removeUnitFromList.bind(this);
		this.onCancel = this.onCancel.bind(this);

		this.state = {
			products:[],
			loading_product:false,
			product_selected:[],
			index_product:-1,
			product_name:"",
			product_id:"",
			lotes:[],
			lote:"",
			stock:"",
			amount:"",
			reasons:[],
			reason:"",

			list:[],
			folio:"",
			date:"",
			hour:"",
		}
	}

	componentDidMount(){
		$(document).on('blur', '#date', (e)=>{
			if(e.target.validationMessage !== ""){
				swal('Error', e.target.validationMessage, 'error');
				
				setTimeout(()=>{
					$('#'+e.target.id).val('')
						.attr('type', 'text')
						.attr('type', 'date');
				}, 4000);

				$('#'+e.target.id).addClass('error');
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});
		
		fetch(Config.default.apiGateway.URL+'plasmatic_product/stock/'+
			sessionStorage.getItem('health_facilities_id'), {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			//this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				
				this.setState({products:response});
				
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=plas_prod_discard_reasons&option=actives&order=true', {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			//this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				
				this.setState({reasons:response});
				
			}
		});

		//fecha y hora
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);
			var aux_date = new Date();

			this.setState({
				date : moment(aux[0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
				hour:hours,
			});
		});

		fetch(Config.default.apiGateway.URL+'plasmatic_product_discards/get_next_folio',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			if(response !== undefined){
				this.setState({
					folio:response
				});
			}
				
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});

		if(e.target.name === 'lote'){
			var stock = parseInt(e.target.options[e.target.selectedIndex].getAttribute('total'));
			this.setState({stock:stock});
		}
	}

	handleTypeAheadChange = (values)=> {

        if(values.length > 0){
        	this.setState({
        		lotes:values[0].stock,
        		product_name:values[0].product.name,
        		product_id: values[0].product.id,
        		index_product:0,
				product_selected:values,
        	})
        	
        }
    }

    addProduct(e){
    	e.preventDefault();

    	var index = this.state.list.findIndex(obj =>
    		obj.id === this.state.product_id &&
    		obj.lote === this.state.lote
    	);

    	var i_prod = this.state.products.findIndex(obj => 
    		obj.product.id === this.state.product_id
    	)

    	var i_cad = this.state.products[i_prod].stock.findIndex(obj => 
    		obj.lot_number === this.state.lote
    	);

    	if(index === -1){
    		if(parseInt(this.state.stock) >= parseInt(this.state.amount)){
    			document.getElementById('amount').classList.remove('error');
    			this.setState({
		    		list:[...this.state.list, {
		    			id:this.state.product_id,
		    			product:this.state.product_name,
		    			lote:this.state.lote,
		    			stock:this.state.stock,
		    			amount:this.state.amount !== "" ? this.state.amount : this.state.stock,
		    			caducidad:moment(this.state.products[i_prod].stock[i_cad].expirate_date).format('DD/MM/YYYY'),
		    			reason:this.state.reason
		    		}],

		    		product_selected:[],
					index_product:-1,
					product_name:"",
					product_id:"",
					lote:"",
					stock:"",
					reason:"",
					amount:""
		    	});
    		}else{
    			swal('Error', 'La cantidad que ingreso no puede ser mayor a la cantidad en stock', 'error');
    			document.getElementById('amount').classList.add('error');
    			document.getElementById('amount').focus = true;
    		}

    		

	    	
    	}else{
    		swal('Error', 'El Producto ya se encuentra en la lista', 'error');
    	}

    }

    removeUnitFromList = (indice) => {
		var array = [...this.state.list];
		array.splice(indice, 1);
		this.setState({list: array});
	}

	onSave(){
		if(this.state.list.length > 0){
			var obj = {
				date:this.state.date !== "" ? moment(this.state.date).format('MM-DD-YYYY') : "",
				hour:this.state.hour !== "" ? moment(this.state.hour, 'HH:mm').format('H:mm:ss') : "",
				folio:this.state.folio,
				details:[]
			}

			this.state.list.map((l)=>{
				obj.details.push({
					product_id:l.id,
					lot_number:l.lote,
					amount:l.amount,
					reason:l.reason
				});
			});

			fetch(Config.default.apiGateway.URL+'plasmatic_product_discards', {
	    		method:'POST',
	    		body:JSON.stringify(obj),
	    		headers: new Headers({
	    			'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
	    			'Accept'		: 'application/json',
	    			'Content-Type'	: 'application/json'	
	    		})
	    	}).then(res => {
	    		if(res.ok){
	    			return 'correcto';// res.json();
	    		}else{
	    			res.text().then((msg)=>{
	    				swal('Error', msg, 'error');
	    			})
	    		}
	    	}).then(response => {
	    		if(response !== undefined){
	    			this.onCancel();
	    			swal('Correcto', 'Los productos fueron dados de baja correctamente', 'success');
	    		}
	    	})

		}else{
			swal('Error', 'Debe agregar por lo menos un producto a la lista', 'error');
		}
	}

	onCancel(){
		this.props.history.push('/plasmatic_products/discard');
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Registro Baja de Productos 
					</h5>
				</div>
				<div className="col-xs-12 form-group">
					<fieldset>
						<legend>Busqueda</legend>
							<div className="col-xs-12">
								<div className="col-xs-12 col-sm-4">
									<span>Producto</span>
									<Typeahead
							          	labelKey={(option) => (`${option.product.name}`)}
							          	minLength={0}
							          	options={this.state.products.length > 0 ? this.state.products : []}
							          	onChange={this.handleTypeAheadChange}	
							            inputProps={{
							          		name:"product",
							          		id:"product",
							          		autoComplete:"off",
							          		required:true
							          	}}
							          	id="auto_product"
							          	isLoading={this.state.loading_product}
							          	useCache={false}
							          	ref={ref => this._typeahead_product = ref}
							          	defaultSelected={this.state.products.slice(this.state.index_product, 1)}
							          	selected={this.state.product_selected}
							          	selectHintOnEnter={true}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
								</div>
								<div className="col-xs-12 col-sm-2">
									<span>Lote</span>
									<select className="form-control" name="lote" id="lote" value={this.state.lote}
										onChange={this.handleChange}>
										<option value="" total="0">Seleccione...</option>
										{this.state.lotes.map((l, i)=>(
											<option key={i} value={l.lot_number} total={l.total}>
												{l.lot_number}
											</option>
										))}
									</select>
								</div>
								<div className="col-xs-12 col-sm-1">
									<span>Stock</span>
									<input className="form-control" name="stock" id="stock" value={this.state.stock} disabled />
								</div>
								<div className="col-xs-12 col-sm-1">
									<span>Cantidad</span>
									<input type="number" className="form-control hour-input" name="amount" id="amount" value={this.state.amount} 
										onChange={this.handleChange} required />
								</div>
								<div className="col-xs-12 col-sm-2">
									<span >Motivo</span>
									<select className="form-control" name="reason" id="reason" value={this.state.reason}
										onChange={this.handleChange}>
										<option value="">Seleccione...</option>
										{this.state.reasons.map((r, i)=>(
											<option key={i} value={r.key}>
												{r.name}
											</option>
										))}
									</select>
								</div>
								<div className="col-xs-12 col-sm-1" style={{marginTop:'18px'}}>
									<button className="btn btn-info" onClick={this.addProduct}>Agregar</button>
								</div>
							</div>
					</fieldset>
					<fieldset>
						<legend>Proceso</legend>
						<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-2">
								<span>Folio</span>
								<input type="text" name="folio" id="folio" value={this.state.folio} onChange={this.handleChange}
									className="form-control" disabled />
							</div>
							<div className="col-xs-12 col-sm-2">
								<span>Fecha</span>
								<input type="date" name="date" id="date" value={this.state.date} onChange={this.handleChange}
									className="form-control input-hour" />
							</div>
							<div className="col-xs-12 col-sm-1">
								<span>Hora</span>
								<input type="time" name="hour" id="hour" value={this.state.hour} onChange={this.handleChange}
									className="form-control input-hour" />
							</div>
						</div>
						<div className="col-xs-12">
							<Table  hover>
								<thead>
									<tr>
										<th>Producto</th>
										<th>Lote</th>
										<th>Stock</th>
										<th>Cantidad</th>
										<th>Caductidad</th>
										<th>Motivo</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{this.state.list.map((l, i)=>(
										<tr key={i}>
											<td>{l.product}</td>
											<td>{l.lote}</td>
											<td>{l.stock}</td>
											<td>{l.amount}</td>
											<td>{l.caducidad}</td>
											<td>{l.reason}</td>
											<td>
												<Button className="btn btn-info btn-xs" title="Eliminar" 
													style={{marginRight:'3px'}} 
													onClick={(e) => this.removeUnitFromList(e, i)}>
						                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
						                        </Button>
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</div>

						<div className="col-xs-12" style={{textAlign:'center'}}>
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
			        			onClick={this.onSave}  style={{margin:12}}/>
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} 
			        			onClick={this.onCancel}/>
				        </div>

					</fieldset>

				</div>
			</div>
		)
	}
}

export default translate('translations')(DiscardProductForm);